import React from 'react';
import PropTypes from 'prop-types';

const BusinessStartupSkills = ({ type }) => {
  if (type === 'freelancer') {
    return (
      <>
        <li>
          <a href="/jobs/ai-engineers">AI engineer jobs</a>
        </li>
        <li>
          <a href="/jobs/app-developers">App developer jobs</a>
        </li>
        <li>
          <a href="/jobs/digital-marketers">Digital marketing jobs</a>
        </li>
        <li>
          <a href="/jobs/pitch-deck-designers">Pitch deck designer jobs</a>
        </li>
        <li>
          <a href="/jobs/brand-designers">Brand designer jobs</a>
        </li>
        <li>
          <a href="/jobs/pr-freelancers">PR freelancer jobs</a>
        </li>
        <li>
          <a href="/jobs/2d-animators">2D animation jobs</a>
        </li>
        <li>
          <a href="/jobs/3d-animators">3D animation jobs</a>
        </li>
        <li>
          <a href="/jobs/web-developesr">Web developer jobs</a>
        </li>
        <li>
          <a href="/jobs/product-designers">Product designer jobs</a>
        </li>
        <li>
          <a href="/jobs/social-media-managers">Social media managers</a>
        </li>
      </>
    );
  }

  return (
    <>
      <li>
        <a href="/find/content-producers/with/explainer-video">
          Explainer Video Experts
        </a>
      </li>
      <li>
        <a href="/find/pitch-deck-designers">Pitch deck designers</a>
      </li>
      <li>
        <a href="/find/content-creators">Content creators</a>
      </li>
      <li>
        <a href="/find/digital-marketers">Digital marketers</a>
      </li>
      <li>
        <a href="/find/social-media-managers">Social media managers</a>
      </li>
      <li>
        <a href="/find/pr-freelancers">PR freelancers</a>
      </li>
      <li>
        <a href="/find/ppc-managers">PPC managers</a>
      </li>
      <li>
        <a href="/find/podcast-producers">Podcast producers</a>
      </li>
      <li>
        <a href="/find/app-developers">App developers</a>
      </li>
      <li>
        <a href="/find/web-developers">Web developers</a>
      </li>
      <li>
        <a href="/find/product-designers">Product designers</a>
      </li>
    </>
  );
};

BusinessStartupSkills.propTypes = {
  type: PropTypes.string.isRequired,
};

export default BusinessStartupSkills;
